import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Container, Grid, Header, Segment} from 'semantic-ui-react';
import DHSInfo from 'go/components/static/DHSInfo';
import LoginGovInfo from 'go/components/static/LoginGovInfo';
import PIVLogin from 'go/components/auth/pivLogin';
import PWLogin from 'go/components/auth/pwLogin';
import LoginGov from 'go/components/auth/loginGov';
import InvalidLoginModal from 'go/components/auth/invalidLoginModal';

export class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {toggles} = this.props;
    const loginGovIntegration = _.includes(toggles, 'loginGovIntegration');
    const passwordRemovalLoginGovIntegration = _.includes(
      toggles,
      'passwordRemovalLoginGovIntegration'
    );

    let authenticationCards;
    if (!loginGovIntegration) {
      authenticationCards = ( // Keep original PWLogin and PIVLogin
        <>
          <Grid.Column mobile={16} computer={8}>
            <PWLogin />
          </Grid.Column>
          <Grid.Column width={8} only="computer">
            <PIVLogin />
          </Grid.Column>
        </>
      );
    } else {
      // loginGovIntegration is on so change content...
      if (!passwordRemovalLoginGovIntegration) {
        // PWLogin, PIVLogin, *and* LoginGov
        authenticationCards = (
          <>
            <Grid.Column mobile={16} computer={8}>
              <PWLogin />
            </Grid.Column>
            <Grid.Column width={8} only="computer">
              <PIVLogin loginGovIntegration={true} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8} stretched>
              <LoginGov />
            </Grid.Column>
          </>
        );
      } else {
        // remove PWLogin and keep LoginGov and PIVLogin
        authenticationCards = (
          <>
            <Grid.Column mobile={16} tablet={8} computer={8} stretched>
              <LoginGov />
            </Grid.Column>
            <Grid.Column width={8} only="computer">
              <PIVLogin loginGovIntegration={true} />
            </Grid.Column>
          </>
        );
      }
    }

    return (
      <div id="main">
        <Container>
          <Segment>
            <Grid>
              <Grid.Column width={16}>
                <Header as="h1">Welcome to FEMA Grants Outcomes!</Header>
                Grants Outcomes (GO) is FEMA's new platform for submitting, approving, and
                managing FEMA grants.
              </Grid.Column>
              {authenticationCards}
            </Grid>
            {loginGovIntegration && <LoginGovInfo />}
            {loginGovIntegration && <InvalidLoginModal />}
            <DHSInfo />
          </Segment>
        </Container>
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {};
};

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
